import { CommonListParams } from "@/types/common";
import request from ".";
import { AddFactoryInventory, FactoryInventory, FactoryInventoryHistory } from "@/types/factoryInventory";

const URL = '/wms/factoryInventory';

const APIS = {
  fInventoryList: URL + '/list',
  fInventoryFetch: (id: string) => `${URL}/${id}/fetch`,
  fInventoryAdd: URL + '/add',
  fInventoryAdjust: URL + '/adjust',
  fInventoryCount: URL + '/counting',
  fInventoryChanges: (id: string) => `${URL}/${id}/changes`
};

export const fInventoryList = (params: CommonListParams) => {
  return new Promise<CommonListParams<Array<FactoryInventory>>>((resolve, reject) => {
    request<Array<FactoryInventory>, string>(APIS.fInventoryList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const fInventoryFetch = (id: string) => {
  return new Promise<FactoryInventory>((resolve, reject) => {
    request<FactoryInventory, string>(APIS.fInventoryFetch(id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const fInventoryAdd = (data: AddFactoryInventory) => {
  return new Promise<FactoryInventory[]>((resolve, reject) => {
    request<FactoryInventory[], AddFactoryInventory>(APIS.fInventoryAdd, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};

export const fInventoryAdjust = (data: AddFactoryInventory) => {
  return new Promise<FactoryInventory[]>((resolve, reject) => {
    request<FactoryInventory[], AddFactoryInventory>(APIS.fInventoryAdjust, { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const fInventoryCount = (data: AddFactoryInventory) => {
  return new Promise<FactoryInventory[]>((resolve, reject) => {
    request<FactoryInventory[], AddFactoryInventory>(APIS.fInventoryCount, { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};


export const fInventoryChanges = (id: string, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<FactoryInventoryHistory>>>((resolve, reject) => {
    request<Array<FactoryInventoryHistory>, string>(APIS.fInventoryChanges(id), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};